import newSpBIDialogTemplate from './newSpBudgetItemDialog.html';
import newSpBIFormTemplate from './newSpBudgetItemForm.html';

angular
   .module('org.saga.newspbudgetitem', ['isolateForm'])
   .directive('newSpBudgetItem', [
      function () {
         return {
            restrict: 'E',
            template: newSpBIFormTemplate,
            scope: {
               newBudgetItem: '=',
               newBudgetItemForm: '='
            },
            controller: [
               '$scope',
               function ($scope) {
                  $scope.costTypes =$scope.newBudgetItem.budgetType === 'PERSONAL_COST' ? personalCostTypes : operatingCostTypes;
               }
            ]
         };
      }
   ])

   .factory('NewSpBudgetItemDialog', [
      '$mdDialog',
      function ($mdDialog) {
         return {
            show: function (budgetItem, totalBudget, budgetLeft, activity, callback) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.budgetItem = budgetItem;
                  $scope.type = budgetItem.budgetType === 'PERSONAL_COST' ? 'osobní' : 'provozní';
                  $scope.totalBudget = totalBudget;
                  $scope.budgetLeft = budgetLeft;
                  $scope.activity = activity;

                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                     $scope.error = false;

                     $mdDialog.hide($scope.budgetItem);
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: newSpBIDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);

const personalCostTypes = [
   'Pracovní smlouva (PS)',
   'Dohoda o provedení práce (DPP)',
   'Dohoda o pracovní činnosti (DPČ)',
   'Odvody zaměstnavatele - zdravotní pojištění',
   'Odvody zaměstnavatele - sociální pojištění',
   'Zákonné pojištění zaměstnavatele',
   'Odměny',
   'Náhrady za dovolenou',
   'Ostatní osobní náklady'
]

const operatingCostTypes = [
   'Provozní náklady - Nájemné kanceláře',
   'Provozní náklady - Energie',
   'Provozní náklady - Kancelářské potřeby',
   'Provozní náklady - Telefon, poštovné, internet',
   'Provozní náklady - Tiskové služby',
   'Provozní náklady - Grafické služby',
   'Provozní náklady - Právní služby',
   'Provozní náklady - Ekonomické služby',
   'Provozní náklady - Překladatelské služby',
   'Provozní náklady - Úklidové služby',
   'Provozní náklady - Ostatní služby',
   'Provozní náklady - Ostatní náklady',
   'Odborná studie/analýza - Zpracování',
   'Odborná studie/analýza - Publikace - grafické práce',
   'Odborná studie/analýza - Publikace - tisk',
   'Průzkum - Analýza současného stavu',
   'Průzkum - Tvorba elektronického dotazníku',
   'Průzkum - Sběr dat',
   'Průzkum - Vyhodnocení dat',
   'Průzkum - Zpracování závěrečné zprávy',
   'Průzkum - Zpracování doporučení',
   'Kulatý stůl - Pronájem sálu',
   'Kulatý stůl - Pronájem techniky',
   'Kulatý stůl - Tlumočení a překladatelské služby',
   'Kulatý stůl - Další služby',
   'Kulatý stůl - Tvorba podkladových materiálů',
   'Kulatý stůl - Tisk podkladových materiálů',
   'Kulatý stůl - Občerstvení',
   'Kulatý stůl - Cestovné - cestovní náklady',
   'Kulatý stůl - Cestovné - ubytování',
   'Kulatý stůl - Publikace/sborník',
   'Kulatý stůl - Kancelářské potřeby - potřeby pro účastníky',
   'Konference - Pronájem sálu',
   'Konference - Pronájem techniky',
   'Konference - Tlumočení a překladatelské služby',
   'Konference - Další služby',
   'Konference - Tvorba podkladových materiálů',
   'Konference - Tisk podkladových materiálů',
   'Konference - Občerstvení',
   'Konference - Cestovné - cestovní náklady',
   'Konference - Cestovné - ubytování',
   'Konference - Publikace/sborník',
   'Konference - Kancelářské potřeby - potřeby pro účastníky',
   'Mezinárodní konference - Pronájem sálu',
   'Mezinárodní konference - Pronájem techniky',
   'Mezinárodní konference - Tlumočení a překladatelské služby',
   'Mezinárodní konference - Další služby',
   'Mezinárodní konference - Tvorba podkladových materiálů',
   'Mezinárodní konference - Tisk podkladových materiálů',
   'Mezinárodní konference - Občerstvení',
   'Mezinárodní konference - Cestovné - cestovní náklady',
   'Mezinárodní konference - Cestovné - ubytování',
   'Mezinárodní konference - Publikace/sborník',
   'Mezinárodní konference - Kancelářské potřeby - potřeby pro účastníky',
   'Medializace / podpůrné materiály - Banner',
   'Medializace / podpůrné materiály - Propagace výstupů v (regionálním) rozhlase',
   'Medializace / podpůrné materiály - Propagace výstupů v (regionálním) tisku',
   'Medializace / podpůrné materiály - Propagační předměty',
   'Medializace / podpůrné materiály - Setkání s novináři',
   'Medializace / podpůrné materiály - Placená mediální kampaň',
   'Medializace / podpůrné materiály - Časopis',
   'Medializace / podpůrné materiály - PR články',
   'Medializace / podpůrné materiály - Školení',
   'Medializace / podpůrné materiály - Informační výjezdy',
   'Ostatní náklady - Specifikace v komentáři',
]
